import styled from 'styled-components';

// Create a Title component that'll render an <h1> tag with some styles
export const StyledCard = styled.div`
    background-color: #FFFFFF;
    box-shadow: 0 3px 10px rgba(0,0,0,.23),0 3px 10px rgba(0,0,0,.16);
    border-radius: 2px;
    border: 0;
    padding-left: 10px ;
    padding-right: 10px ;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 15px
`;


export const PanelHeader = styled.div`
    padding-bottom: 10px;
    padding-top: 10px
    border-bottom: 1px solid transparent;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    `;

export const PanelBody = styled.div`
    padding-bottom: 10px;
    padding-top: 10px
    border-bottom: 1px solid transparent;
    `;

export const PanelTitle = styled.h3`
    margin-top: 0;
    margin-bottom: 0;
    font-size: 20px;
    color: inherit;
`;



// WEBPACK FOOTER //
// ./src/styleHelper.jsx